import { Button } from "@akin2unde/flowui-react";
import { ErrorDisplay } from "./ErrorDisplay";
import type { ErrorDisplayProps } from "./ErrorDisplay";
import "./ErrorDisplayCss.css";

export default function ErrorDisplayHTML(props: ErrorDisplayProps) {
  const { isOpen, title, message, validationErrors, onClose } =
    ErrorDisplay(props);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="error-display-overlay"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="error-display-title"
    >
      <div className="error-display-dialog">
        <div className="error-display-icon">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
        </div>

        <div className="error-display-body">
          <h2 id="error-display-title" className="error-display-title">
            {title}
          </h2>

          {message && <p className="error-display-message">{message}</p>}

          {validationErrors.length > 0 && (
            <ul className="error-display-validation-list">
              {validationErrors.map((validationError, index) => (
                <li key={`${validationError.property}-${index}`}>
                  {validationError.message}
                </li>
              ))}
            </ul>
          )}

          <div className="error-display-actions">
            <Button onClick={onClose}>Close</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
